<template>
  <TextBlob headingSize="s">
    <template #heading> ChangeLog </template>
    <template #text>
      <span v-html="newUpdates"></span>
    </template>
  </TextBlob>
</template>
<script setup>
import TextBlob from "@/components/TextBlob.vue";
import { computed } from "vue";
import { useChangelog } from "@/composables/useChangelog";

const { allUpdates } = useChangelog();
const newUpdates = computed(() => allUpdates.value);
</script>
